import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _blogCache = { updatedDate: 'google.protobuf.Timestamp' };
var _getBlogCacheRequest = {};
var _getBlogCacheResponse = { blogCache: '_blogCache' };
function resolveWixBlogV1BlogCacheServiceUrl(opts) {
    var domainToMappings = {
        'bo._base_domain_': [
            {
                srcPath: '/_api/blog-cache-service',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/blog-cache-service',
                destPath: '',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/blog-cache-service',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/blog-cache-service',
                destPath: '',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/_api/blog-cache-service',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/blog-cache-service',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/blog-cache-service',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/blog-cache-service',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/blog-cache-service',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/blog-cache-service',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/blog-cache-service',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/blog-cache-service',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Gets blog cache. */
export function getBlogCache(payload) {
    var _a = serializer(_getBlogCacheRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getBlogCacheResponse, {
        _blogCache: _blogCache,
    }).fromJSON;
    function __getBlogCache(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v1.blog_cache',
            method: 'GET',
            methodFqn: 'wix.blog.v1.BlogCacheService.GetBlogCache',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixBlogV1BlogCacheServiceUrl({
                protoPath: '/v1/blog-cache',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getBlogCache.fromReq = fromReq;
    __getBlogCache.__isAmbassador = true;
    return __getBlogCache;
}
//# sourceMappingURL=http.impl.js.map